import { Component, Inject, inject } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';

@Component({
  selector: 'app-dialog-uploading',
  templateUrl: './dialog-uploading.component.html',
  styleUrl: './dialog-uploading.component.scss'
})
export class DialogUploadingComponent {


  public _dialogRef = inject(MatDialogRef<DialogUploadingComponent>);
 
  
}


